import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Opt a single request out of the global error dialog raised by `HttpErrorInterceptor`, for calls
 * whose failure is expected and already handled at the call site (a background lookup that simply
 * has no answer, for instance).
 */
export const SKIP_ERROR_DIALOG = new HttpContextToken<boolean>(() => false);

export function skipErrorDialog(): HttpContext {
  return new HttpContext().set(SKIP_ERROR_DIALOG, true);
}
